
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations } from 'vuex';
import { linkedInUrl } from '~/components/utils/validate/rules';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import BravadoCallout from '~/components/common/BravadoCallout/BravadoCallout.vue';
import type { FormState } from '~/types/common';
import TriggerLinkedInScraping from '~/apollo/mutations/Portfolio/TriggerLinkedInScraping.mutation';

type PublicPortfolioLinedinImportModalData = {
  form: { linkedinUrl: string };
  formState: FormState;
};

export default Vue.extend({
  name: 'PublicPortfolioLinkedinImportModal',
  components: { PublicPortfolioModal, BravadoButtonV3, BravadoTextInputV3, BravadoCallout },
  mixins: [validationMixin],
  props: {
    linkedinUrl: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
  validations: {
    form: {
      linkedinUrl: {
        required,
        linkedInUrl,
      },
    },
  },
  data(): PublicPortfolioLinedinImportModalData {
    return {
      form: { linkedinUrl: this.linkedinUrl },
      formState: 'idle',
    };
  },
  computed: {
    linkedInError(): string {
      const linkedinUrl = this.$v.form.linkedinUrl!;

      if (this.formState === 'error' && linkedinUrl.$invalid) {
        if (!linkedinUrl.required) return 'LinkedIn URL is required';
        if (!linkedinUrl.linkedInUrl) return 'Provide a valid LinkedIn URL';

        return '';
      } else {
        return '';
      }
    },
    isNextButtonDisabled(): boolean {
      if (this.formState === 'error') return this.$v.form.$invalid;
      return false;
    },
  },
  methods: {
    ...mapMutations('portfolio', ['updateLinkedInImportState']),
    ...mapActions('portfolio', ['updateUser']),
    async startLinkedInImport() {
      if (this.$v.form.$invalid) {
        this.formState = 'error';
      } else {
        if (this.linkedinUrl !== this.form.linkedinUrl) {
          await this.updateUser({ user: { linkedin_url: this.form.linkedinUrl } });
        } else {
          await this.$apollo.mutate({ mutation: TriggerLinkedInScraping, variables: { input: {} } });
        }

        this.updateLinkedInImportState('pending');

        this.$analytics.logEvent('public-portfolio__onboarding__next-step', {
          to: 'add-clients',
          from: 'linkedin-link',
        });
        await this.$router.push(`?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_ADD_CLIENTS_MODAL}`);
      }
    },
  },
});
